import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import rest from "../../rest";
import DetailsMail from "./detailMail";
import VisibilityIcon from "@material-ui/icons/Visibility";
import HistoryIcon from "@material-ui/icons/History";

import { useModal } from "../../components/general/modalContext";
import { IconButton, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { themeColors } from "../../components/css/themeConfig";
import { ThemeProvider } from "@material-ui/core/styles";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";

import createCustomTheme from "../../components/dataTable/CustomThemeTable";
import textLabels from "../../components/dataTable/textLabel";

const HistoriqueTable = ({ refreshParent }) => {
  const { openModal, closeModal } = useModal();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const themeName =
    useSelector((state) => state.manif?.manifParams?.Theme) || "theme1";

  useEffect(() => {
    setLoading(true);
    rest
      .post("/benevols/historiqueContactMail.json")
      .then((response) => {
        setData(response.data?.Historique);
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération des données historiqueContactMail :",
          error
        );
        setLoading(false);
      });
  }, [refreshParent]);

  const hundelDetail = (rowData) => {
    console.log(rowData);
    const params = {
      vNumEnvoie: rowData[6],
    };

    rest
      .post("/benevols/historiqueContactMailDetail.json", params)
      .then((response) => {
        openModal(
          "Détails mail envoyé: ",
          <DetailsMail data={response.data.Details} closeModal={closeModal} />
        );
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération des details de mail :",
          error
        );
      });
  };

  // Colonnes du tableau
  const columns = [
    { name: "idEmail", label: "ID Email", options: { display: false } },
    { name: "dateEnvoie", label: "Date d'envoi" },
    {
      name: "expediteur",
      label: "Expéditeur",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const modeleIndex = columns.findIndex((col) => col.name === "modele");
          if (modeleIndex !== -1) {
            const modele = tableMeta.rowData[modeleIndex];
            if (
              modele === "Fiche benevole" ||
              modele === "Réattribution" ||
              modele === "Liste d'attente" ||
              modele === "Désinscription" ||
              modele === "Attestation benevole"
            ) {
              return "Système";
            }
          }
          return value;
        },
      },
    },
    {
      name: "groupeDest",
      label: "Groupe de destination",

      options: {
        display: false,
        setCellProps: () => ({
          style: {
            maxWidth: "250px",
            whiteSpace: "normal",
            wordBreak: "break-word",
          },
        }),
        customBodyRender: (value) => {
          return value ? value : "Aucun";
        },
      },
    },
    {
      name: "listGroupeDestinataireText",
      label: "Destinataires",
      options: {
        setCellProps: () => ({
          style: {
            minWidht: "500px",
            maxWidth: "900px",
            whiteSpace: "normal",
            wordBreak: "break-word",
          },
        }),
        customBodyRender: (value, tableMeta, updateValue) => {
          if (!value) {
            return "Aucun";
          }

          const formattedValue = value.split(",").map((item, index) => (
            <React.Fragment key={index}>
              {item}
              <br />
            </React.Fragment>
          ));

          return <div>{formattedValue}</div>;
        },
      },
    },
    {
      name: "modele",
      label: "Modèle",
      options: {
        customBodyRender: (value) => {
          return value ? value : "Libre";
        },
      },
    },

    { name: "numEnvoie", label: "Numéro d'envoi", options: { display: false } },
    { name: "nbEnvoie", label: "Nombre d'envois" },
    { name: "nbEmail", label: "Nombre d'emails" },
    { name: "nbPapier", label: "Nombre de papiers" },
    { name: "nbSansAdresse", label: "Nombre sans adresse" },
    {
      name: "details",
      label: "Détails",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <IconButton onClick={(e) => hundelDetail(tableMeta.rowData)}>
              <VisibilityIcon />
            </IconButton>
          );
        },
      },
    },
  ];

  const options = {
    search: true, // Activer le champ de recherche
    filter: false, // Désactiver le filtre
    sort: false, // Désactiver le tri
    download: false, // Désactiver l'export
    print: false, // Désactiver l'impression
    selectableRows: "none", // Désactiver la sélection de lignes
    viewColumns: false, // Désactiver l'affichage des colonnes
    pagination: true, // Désactiver la pagination
    responsive: "simple",
    textLabels: textLabels,
  };

  const theme = createCustomTheme(
    themeColors[themeName].headerColor,
    themeColors[themeName].color
  );

  return (
    <>
      <LoadingIndicator open={loading} />

      <ThemeProvider theme={theme}>
        <MUIDataTable
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <HistoryIcon style={{ marginRight: 16, marginLeft: -8 }} />
              <Typography variant="h5">Historique</Typography>
            </div>
          }
          data={data}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </>
  );
};

export default HistoriqueTable;
